import { TITLE_COPY_LIMITS } from "../copy-policy";
export const logoWallSchema = {
    componentId: "LogoWall",
    scalarSlots: [
        { key: "heading", ...TITLE_COPY_LIMITS, label: "Heading", type: "text" },
        { key: "columns", label: "Columns (2-6)", type: "number" },
        { key: "grayscale", label: "Greyscale logos", type: "boolean" },
    ],
    mediaSlots: [],
    repeatSlots: [
        {
            key: "logos",
            label: "Logos",
            itemLabel: "Logo",
            scalarSlots: [
                { key: "alt", label: "Alt text", type: "text" },
                { key: "href", label: "Link", type: "url" },
                { key: "caption", label: "Caption", type: "text" },
            ],
            mediaSlots: [
                {
                    key: "logo",
                    label: "Logo image",
                    targets: [{ width: 200, height: 80 }],
                },
            ],
        },
    ],
};
//# sourceMappingURL=logo-wall.js.map